var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GenericCardColumns,[_c(_setup.AccountInvitesCard),_vm._v(" "),_c(_setup.BookingsTotalCard),_vm._v(" "),_c(_setup.SpentBudgetCard),_vm._v(" "),_c(_setup.LearningTypeTop5Card),_vm._v(" "),_c(_setup.InstitutesTop5Card),_vm._v(" "),_c(_setup.CategoriesTop5Card)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }